<template>
    <div class="pdf-container-outer">
        <div v-if="loadingProgress" class="loadingContainer">
            <div id="progress" class="progressBar">
                <div id="progress-value">
                    {{ progress }} %
                </div>
            </div>
            <p style="margin-top: 150px;">{{ translate('loading') }}</p>
        </div>

        <div class="pdf-controller" v-if="controllerVisible">
            <div class="pdf-controller-inner">
                <template v-if="isLoading">
                    {{ translate('loading') }}
                </template>

                <template v-else>
                    <span v-if="showAllPages">
                        {{ pageCount }} {{ translate('page') }}
                    </span>

                    <span v-else>
                        <button class="btn btn-sm navigationButtons" type="button" :disabled="page <= 1" @click="page--"><svg
                                xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24"
                                fill="none">
                                <path d="M15 6L9 12L15 18" stroke="#fff" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" />
                            </svg></button>

                        {{ page }} / {{ pageCount }}

                        <button class="btn btn-sm navigationButtons" :disabled="page >= pageCount" type="button" @click="page++"><svg
                                xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24"
                                fill="none">
                                <path d="M9 6L15 12L9 18" stroke="#fff" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" />
                            </svg></button>
                    </span>

                    <label class="right">
                        <input v-model="showAllPages" type="checkbox">
                        {{ translate('showAllPages') }}
                    </label>
                    <div v-if="!showAllPages">
                        <button class="btn btn-sm rotationButtons" type="button" @click="rotate(0)"><svg
                                xmlns="http://www.w3.org/2000/svg" fill="#fff" width="24px" height="24px"
                                viewBox="0 0 1920 1920">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                    d="M1251.45 447.883 1120 316.432h160c176.73 0 320 143.269 320 320h106.67c0-235.641-191.03-426.666-426.67-426.666h-159.97l134.34-134.341L1178.94 0 915.833 263.111l260.197 260.196 75.42-75.424Zm28.55 405.45C1280 735.513 1184.49 640 1066.67 640H213.333C95.513 640 0 735.513 0 853.333v853.337C0 1824.49 95.513 1920 213.333 1920h853.337c117.82 0 213.33-95.51 213.33-213.33V853.333Zm-213.33-106.666H213.333c-58.91 0-106.666 47.756-106.666 106.666v853.337c0 58.91 47.756 106.66 106.666 106.66h853.337c58.91 0 106.66-47.75 106.66-106.66V853.333c0-58.91-47.75-106.666-106.66-106.666Z" />
                            </svg></button>
                        <button class="btn btn-sm rotationButtons" type="button" @click="rotate(1)"><svg
                                xmlns="http://www.w3.org/2000/svg" fill="#fff" width="24px" height="24px"
                                viewBox="0 0 1920 1920">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                    d="M639.999 209.777h116.019L621.665 75.425 697.09 0l263.111 263.111-260.196 260.196-75.425-75.424 131.439-131.439h-116.02c-176.731 0-320 143.269-320 320H213.332c0-235.642 191.025-426.667 426.667-426.667Zm0 643.556c0-117.82 95.512-213.333 213.333-213.333h853.338c117.82 0 213.33 95.513 213.33 213.333v853.337c0 117.82-95.51 213.33-213.33 213.33H853.332c-117.821 0-213.333-95.51-213.333-213.33V853.333Zm213.333-106.666h853.338c58.91 0 106.66 47.756 106.66 106.666v853.337c0 58.91-47.75 106.66-106.66 106.66H853.332c-58.91 0-106.667-47.75-106.667-106.66V853.333c0-58.91 47.757-106.666 106.667-106.666Z" />
                            </svg></button>
                    </div>
                </template>
            </div>
        </div>
        <vue-pdf-embed ref="pdfComp" @progress="loadingProgess" :rotation="rotationAngle" :annotationLayer="true"
            :textLayer="true" :source="pdfUrl" :page="page" @rendered="handleDocumentRender" :width="calculateWidth()" />
    </div>
</template>

<script>
import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed.js'

export default {
    props: {
        pdfUrl: null,
        controllerVisible: {
            type: Boolean,
            default: true
        }
    },
    components: {
        VuePdfEmbed,
    },
    data() {
        return {
            isLoading: true,
            page: null,
            pageCount: 1,
            showAllPages: true,
            progress: 0,
            loadingProgress: true,
            rotationAngle: 0,
        }
    },
    created() {
        this.calculateWidth()
    },
    watch: {
        showAllPages() {
            this.page = this.showAllPages ? null : 1
        },
    },
    methods: {
        rotate(direction) {
            // direction 1 means 90 degrees to right
            // direction 0 means 90 degrees to left
            if (direction == 1) {
                this.rotationAngle += 90
            } else {
                this.rotationAngle -= 90
            }
        },
        calculateWidth() {
            const width = screen.width * 0.4
            return width;
        },
        handleDocumentRender() {
            this.isLoading = false
            this.pageCount = this.$refs.pdfComp.pageCount
        },
        loadingProgess(e) {
            this.progress = ((e.loaded * 100) / e.total).toFixed(0)
            if (this.progress == 100) {
                this.loadingProgress = false;
            }
            if (this.loadingProgress != false) {
                let scrollProgress = document.getElementById("progress");
                scrollProgress.style.background = `conic-gradient(#0571ff ${this.progress}%, #d7d7d7 ${this.progress}%)`;
            }

        },
    }
}
</script>

<style>
.pdf-controller {
    position: fixed;
    z-index: 2;
    bottom: 60px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease-in-out;
}

.pdf-controller-inner {
    display: flex;
    padding: 16px;
    padding-left: 30px;
    padding-right: 30px;
    justify-content: center;
    align-items: center;
    gap: 20px;
    box-shadow: 0 2px 8px 4px rgba(0, 0, 0, 0.216);
    background-color: #323232;
    color: #ddd;
    border-radius: 165px;
    transition: all 0.2s ease-in-out;
}

.pdf-controller-inner label {
    margin: 0;
}

.vue-pdf-embed>div {
    margin-bottom: 14px;
    box-shadow: 0 2px 8px 4px rgba(0, 0, 0, 0.1);
}

.pdf-container-outer {
    display: flex;
    justify-content: center;
}

.progressBar {
    border-radius: 9999px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    height: 6rem;
    width: 6rem;
    cursor: pointer;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
}

#progress {
    transition: opacity 0.2s ease-in-out;
    opacity: 1;
}

#progress-value {
    height: calc(100% - 8px);
    width: calc(100% - 8px);
    display: block;
    background-color: rgb(255, 255, 255);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;

}

.loadingContainer {
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 200px;
    align-items: center;
}

.navigationButtons {
    border: 1px solid transparent;
    background-color: rgba(36, 36, 36, 0.06);
    transition: 0.2s all ease-in-out;
}
.navigationButtons:hover {
    background-color: #3b3b3b;
}
.rotationButtons {
    border: 1px solid transparent;
    transition: 0.2s all ease-in-out;
}

.rotationButtons:hover {
    background-color: #3b3b3b;
}
</style>